import React, { useEffect, useState } from 'react'

import CssBaseline from '@mui/material/CssBaseline'
import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import ReactDOM from 'react-dom'

import { ContextDataProvider } from './contexts/DataContext'
import reportWebVitals from './reportWebVitals'
import GlobalStyles from './styles/global'
import theme from './styles/theme'
import router from './router'
import { ToastProvider } from './components/ToastProvider'

ReactDOM.render(
  <ContextDataProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <RouterProvider router={router} />
      <ToastProvider />
    </ThemeProvider>
  </ContextDataProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
